import styled from 'styled-components'

export const HelpSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: ${({ theme }) => theme.spacing[2]};
`

export const HelpTitle = styled.div`
    font-size: ${({ theme }) => theme.typography.fontSize.lg};
    color: ${({ theme }) => theme.colors.greyScale[50]};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`

export const HelpContent = styled.div`
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    color: ${({ theme }) => theme.colors.greyScale[100]};
    line-height: 2;
`

export const SubText = styled.span`
    color: ${({ theme }) => theme.colors.greyScale[50]};
`
